<mat-toolbar class="custom-toolbar">
    <button mat-icon-button class="white-icon" aria-label="back clicked" (click)="backClicked()">
        <mat-icon class="volume-icon">close</mat-icon>
    </button>
    <span class="toolbar-spacer"></span>
    <span class="toolbar-title">{{currentDate}}</span>
    <span class="toolbar-spacer"></span>
    <button mat-icon-button class="white-icon" aria-label="read text" (click)="volumeClicked()">
        <mat-icon>volume_up</mat-icon>
    </button>
</mat-toolbar>
<div id="img-container">
  <img class="topImage" [src]="adviceImg" width="345" height="267">
    <button id="measure-btn" mat-fab color="primary" class="rotate-45" (click)="onFabClicked()">
      <mat-icon>straighten</mat-icon>
    </button>
</div>

<mat-grid-list cols="3" rowHeight="2:1" gutterSize="12px" style="padding-top: 64px">
  <mat-grid-tile>
    <div class="vertical">
      <span class="vertical-align-middle txt-font">{{wateringDecision}}</span>
      <Label class="description" textWrap="true">{{ "WATERING ADVICE" }}</Label>
    </div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="vertical">
      <span class="vertical-align-middle txt-font">{{stageNumber}}</span>
      <Label class="description" textWrap="true">{{ "GROWTH STAGE" }}</Label>
    </div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="vertical">
      <span class="vertical-align-middle color-medium txt-font">{{soilMoistureLevel}}</span>
      <Label class="description" textWrap="true">{{"SOIL MOISTURE"}}</Label>
    </div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="vertical">
      <span class="vertical-align-middle txt-font">{{plantingDays}}d</span>
      <Label class="description" textWrap="true">{{ "SINCE PLANTING" }}</Label>
    </div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="vertical">
      <div class="imgHolder">
        <mat-icon class="vertical-align-middle txt-font yellow">wb_sunny</mat-icon>
        <span class="vertical-align-middle temp">{{temperature}}&deg;C</span>
      </div>
      <Label class="description" textWrap="true">{{"TEMPERATURE"}}</Label>
    </div>
  </mat-grid-tile>
  <mat-grid-tile>
    <div class="vertical">
      <div class="imgHolder">
        <mat-icon class="vertical-align-middle txt-font blue">wb_cloudy</mat-icon>
        <span class="vertical-align-middle temp">{{rainfallPercentage}}%</span>
      </div>
      <Label class="description" textWrap="true">{{"RAINFALL"}}</Label>
    </div>
  </mat-grid-tile>
</mat-grid-list>
